<mat-card>
    <mat-card-header>
        <mat-card-title>
            Hallo, <b> {{ userService.UserName }} </b>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content></mat-card-content>
</mat-card>